import { render, staticRenderFns } from "./DetailedStock.vue?vue&type=template&id=7d0b1af5&scoped=true"
import script from "./DetailedStock.vue?vue&type=script&lang=js"
export * from "./DetailedStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0b1af5",
  null
  
)

export default component.exports